'use client';

import { VStack } from '@terra/ui-styled-system';
import {
  ApiDocumentationRequiredAlert,
  ApplicationDocumentationCard,
} from '@terra/ui-design-system';
import { useApplicationDocumentationController } from '../../../hooks/api/useApplicationDocumentationController';

type TargetDocumentationPanelProps = {
  applicationId: string;
  isBackendOnly: boolean;
  isReadOnly: boolean;
};

export function TargetDocumentationPanel({
  applicationId,
  isBackendOnly,
  isReadOnly,
}: TargetDocumentationPanelProps) {
  const controller = useApplicationDocumentationController({ applicationId });
  const showApiDocumentationRequiredAlert =
    isBackendOnly && controller.apiDocumentationFiles.length === 0;

  return (
    <VStack alignItems="stretch" gap={4} w="full">
      {showApiDocumentationRequiredAlert ? (
        <ApiDocumentationRequiredAlert />
      ) : null}
      <ApplicationDocumentationCard
        applicationId={applicationId}
        controller={controller}
        isReadOnly={isReadOnly}
        showApiRequiredBadge={isBackendOnly}
      />
    </VStack>
  );
}
